import { actionCreators } from 'app/area/bowtie/actions';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

export function useActionCreators() {
  const dispatch = useDispatch();
  return useMemo(
    () => bindActionCreators(actionCreators, dispatch), 
    [dispatch]
  );
}
